// extracted by mini-css-extract-plugin
export var option = "_55-1";
export var optionActive = "_55-2";
export var pill = "_55-0";